import Vue from "vue";
import Router from "vue-router";
import Index from "./views/Index.vue";
import Login from "./views/Login.vue";
import NotFound from "./views/NotFound.vue";
import Statis from "@/views/Statis";

Vue.use(Router);

const router = new Router({
  mode: "hash",
  // base: process.env.BASE_URL,
  routes: [
    {
      path: "/login",
      component: Login,
    },
    {
      path: "/statis",
      component: Index,
      children: [
        {
          path: "/statis",
          name: "statis",
          component: Statis,
        },
        {
          path: "/404",
          component: NotFound,
        },
      ],
    },
    {
      path: "*",
      redirect: { path: "/404" },
    },
  ],
});

// 全局路由守卫
router.beforeEach((to, from, next) => {
  const LOGINURL = "/login";
  let url, user;

  url = to.path;
  user = sessionStorage.getItem("user");

  if (url === LOGINURL) {
    sessionStorage.removeItem("user");
  }

  // 判断是否登录
  if (!user && url !== LOGINURL) {
    next({ path: LOGINURL });
  } else {
    next();
  }
});

export default router;
